import React from "react";
import { Grid } from "@mui/material";
import TableInc from "../../../../shared-ui/TableInc";
import ButtonInc from "../../../../shared-ui/ButtonInc";

// Mirrors containers/PartnerStatus/components/view/ViewPolicyMakerChecks.js (the
// partner-level policy maker-check editor), adapted for product-level
// policy_maker_checks: this list is local form state (no dedicated CRUD
// endpoints), submitted as part of the whole product save.
export default function ViewProductPolicyMakerChecks(props) {
  var checks = props.policyMakerChecks || [];
  var onAddCheck = props.onAddCheck;
  var onEditCheck = props.onEditCheck;
  var onDeleteCheck = props.onDeleteCheck;

  var sortedChecks = checks.slice().sort(function(a, b) {
    return (a.sequence || 0) - (b.sequence || 0);
  });

  return (
    <div>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ marginBottom: 12 }}
      >
        <Grid item>
          <h3 style={{ margin: 0 }}>Policy Maker-Checker Sequence</h3>
        </Grid>
        <Grid item>
          <ButtonInc variant="contained" color="primary" onClick={onAddCheck}>
            + Add Check
          </ButtonInc>
        </Grid>
      </Grid>

      <TableInc
        columns={[
          {
            title: "Sequence",
            field: "sequence",
            render: function(row) {
              return row.sequence != null ? "#" + row.sequence : "—";
            },
          },
          {
            title: "Type",
            field: "type",
            render: function(row) {
              return row.type || "—";
            },
          },
          {
            title: "Label",
            field: "label",
            render: function(row) {
              return row.label || "(no label)";
            },
          },
          {
            title: "Skippable",
            field: "allow_to_skip",
            render: function(row) {
              return row.allow_to_skip ? "Yes" : "No";
            },
          },
        ]}
        data={sortedChecks}
        actions={[
          {
            icon: "edit",
            tooltip: "Edit check",
            onClick: function(e, row) {
              onEditCheck(row);
            },
          },
          {
            icon: "delete",
            tooltip: "Delete check",
            onClick: function(e, row) {
              onDeleteCheck(row);
            },
          },
        ]}
        options={{
          showTitle: false,
          actionsColumnIndex: -1,
          pageSize: 5,
          search: false,
          emptyRowsWhenPaging: false,
        }}
        localization={{
          body: {
            emptyDataSourceMessage: "No policy maker checks configured for this product yet.",
          },
        }}
      />
    </div>
  );
}
